export const TEMPLATE_FORM_FIELD_IDS = {
  TEMPLATE_NAME: 'template-name',
  REPORT_SELECT: 'report-select',
  REPORT_SELECT_EMPTY: 'report-select-empty'
};
